var scope_0 = require('/Users/mcruz/Documents/Developer/gatsby/appuro-hortodaquinta-com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3cf6eed399ea31de00d9a07ec6e82624.js').default;export default
        Object.assign({}, scope_0 )
    